module.exports = __webpack_public_path__ + "images/Greg_Rubicon.jpg?v=154f5bf128b0865988d13f6f7bdad096";